<template >
  <div class="mainbody">
    <div class="mainTitle">
      <h3>激活日志列表</h3>
      <p>记录对邮箱激活数据的操作，方便找回</p>
    </div>

    <div class="mainBody">
      <div class="main_head">
        <div class="main_head_left">
          <div>
            <div class="input_parent">
              <el-input class="input" v-model="where_apply_id" placeholder="请输入" size></el-input>
              <span>申请单号(序号):</span>
            </div>
            <div class="input_parent">
              <el-input class="input" v-model="where_student_no" placeholder="请输入" size></el-input>
              <span>学号:</span>
            </div>
            <div class="input_parent">
              <el-input class="input" v-model="where_name" placeholder="请输入" size></el-input>
              <span>姓名:</span>
            </div>
          </div>
        </div>
        <div class="main_head_right">
          <el-button type="primary" @click="query()">查询</el-button>
          <el-button @click="reset()">重置</el-button>
        </div>
      </div>
      <!-- <div style="clear: both"></div> -->

      <el-table v-loading="tableLoading" :data="tableData" @sort-change="changeTableSort">
        <el-table-column prop="apply_id" label="序号" min-width="1" sortable="custom"></el-table-column>
        <el-table-column prop="student_no" label="学号" min-width="1" sortable="custom"></el-table-column>
        <el-table-column prop="name" label="姓名" min-width="1" sortable="custom"></el-table-column>
        <el-table-column prop="mobile" label="手机号码" min-width="1" sortable="custom"></el-table-column>
        <el-table-column prop="result" label="结果" min-width="1" sortable="custom"></el-table-column>
        <el-table-column prop="create_time" label="申请时间" min-width="2"></el-table-column>
        <el-table-column prop="remark" label="备注" min-width="3"></el-table-column>
      </el-table>
      <div class="elPaginationDiv">
        <el-pagination
          :key="elementui_page_key"
          class="elPagination"
          background
          layout="prev, pager, next"
          :page-size="pageMaxSize"
          :page-count="pageCount"
          :current-page="currentPage"
          @current-change="currentChange"
        ></el-pagination>
        <span class="paginationPageNum">第{{ thispageNum }}条，总共{{ recordCount }}条</span>
      </div>
    </div>
  </div>
</template>
<script>
import { URL_PATH, LIST_PAGE_MAX_SIZE } from '@/config/config'
import * as Constant from '@/utils/constant.js'
import * as StrUtils from '@/utils/strUtils.js'
import * as CApi from '@/api/constant_api.js'
import * as Api from '@/api/api.js'
import leftMeun from '@/components/layout/leftMeun'
import headerLayout from '@/components/layout/headerLayout'
import headRight from '@/components/layout/headRight'

export default {
  components: {
    leftMeun,
    headerLayout,
    headRight
  },
  data() {
    return {
      tableLoading: false,
      meunItem: null,
      meunTitle: '',
      pageMaxSize: LIST_PAGE_MAX_SIZE,
      pageCount: 0,
      selectSize: 0,
      recordCount: 0,
      thispageNum: '1-' + LIST_PAGE_MAX_SIZE,

      elementui_page_key: 1,
      currentPage: 1,
      order: '',
      where_name: '',
      where_apply_id: '',
      where_student_no: '',

      tableData: []
    }
  },
  mounted() {
    var that = this
    document.onkeydown = function (e) {
      const keyCode = event.keyCode ? event.keyCode : event.which ? event.which : event.charCode
      // 回车键查询
      if (keyCode == 13) that.query()
    }
  },
  activated() {
    this.getList()
  },
  deactivated() {},
  created() {
    this.getList()
  },
  methods: {
    currentChange(val) {
      this.elementui_page_key++
      this.currentPage = val
      this.getList()
    },
    // 排序
    changeTableSort(column) {
      this.order = StrUtils.getPropOrder(column)
      this.query()
    },
    // 服务端获取数据
    getList: function () {
      this.tableLoading = true
      this.$api
        .getApplyLog({
          token: localStorage.getItem('token'),
          page: this.currentPage,
          limit: this.pageMaxSize,

          order: this.order,
          where_name: this.where_name,
          where_apply_id: this.where_apply_id,
          where_student_no: this.where_student_no
        })
        .then(({ data }) => {
          this.recordCount = data.Data.recordCount
          var currentPage = data.Data.currentPage
          var startIndex = (currentPage - 1) * this.pageMaxSize + 1
          var endIndex = startIndex + this.pageMaxSize - 1
          if (endIndex > this.recordCount) {
            endIndex = this.recordCount
          }
          this.thispageNum = startIndex + '-' + endIndex
          this.pageCount = data.Data.pageCount
          this.tableData = data.Data.model

          this.tableData.forEach(tData => {
            tData.result = StrUtils.activateSucOrFail(tData.result)
          })

          this.tableLoading = false
        })
        .catch(({ error }) => {
          this.tableLoading = false
          if (error != undefined) {
            console.log(error)
          }
        })
    },
    // 查询
    query: function () {
      this.currentPage = 1
      this.getList()
    },
    // 搜索重置
    reset: function () {
      this.order = ''
      this.where_name = ''
      this.where_apply_id = ''
      this.where_student_no = ''

      this.query()
    }
  }
}
</script>

<style lang="less" scoped>
.mainTitle {
  background-color: #ffffff;
  border-radius: 5px;
  padding: 50px 20px  0 40px;
}
.mainBody {
  margin-top: 10px;
  padding: 20px 30px 15px 20px;
  background-color: #ffffff;
  border-radius: 5px;
}
.main_head {
  width: 100%;
}
.main_head_left {
  margin-left: -20px;
  width: 85%;
  float: left;
}
.selectTitle {
  padding-left: 10px;
  margin-top: 15px;
  background-color: #eff9fe;
  border-radius: 3px;
  border: 1px solid #2383e0;
  height: 40px;
  line-height: 40px;
}
.selectTitleNum {
  color: #2383e0;
}
.selectTitleClear {
  color: #2383e0;
  margin-left: 20px;
  cursor: hand;
}
</style>
<style lang="less">
.el-date-editor--daterange.el-input,
.el-date-editor--daterange.el-input__inner,
.el-date-editor--timerange.el-input,
.el-date-editor--timerange.el-input__inner {
  width: 60%;
}
</style>


// WEBPACK FOOTER //
// src/components/applyLog/applyLogList.vue